import React, { useContext } from "react";
import { GoogleLogin } from "react-google-login";
import { MDBBtn, MDBIcon } from "mdbreact";

import { refreshTokenSetup } from "../refreshToken";
import { UserContext } from "./UserContext";

export default function Login() {
  const userContext = useContext(UserContext);

  const ResponseGoogle = (response) => {
    console.log(response.tokenId);
    userContext.login(
      response.profileObj.name,
      response.profileObj.email,
      response.tokenId
    );
    refreshTokenSetup(response);
  };

  const customStyle = {
    backgroundColor: "deep-orange",
    background: "deep-orange",
    border: "none",
    fontWeight: "bold",
  };

  return (
    <div>
      <GoogleLogin
        clientId="406717518600-fs8c8b613002m815p8ihhfb5s1vvjdoj.apps.googleusercontent.com"
        isSignedIn={userContext.signedIn}
        render={(renderProps) => (
          <MDBBtn
            color="red"
            onClick={renderProps.onClick}
            className="mt-3"
            style={customStyle}
          >
            <div className="text-center my-1">
              <MDBIcon fab icon="google" style={{ fontSize: "large" }} />
              <span> &nbsp;Login with Google </span>
            </div>
          </MDBBtn>
        )}
        onSuccess={ResponseGoogle}
        onFailure={ResponseGoogle}
        cookiePolicy="single_host_origin"
      />
    </div>
  );
}
